import React, { useContext } from "react";
import { BrowserRouter } from "react-router-dom";
import Router  from "./Router.js";

import LoginContext from "./context/Login/LoginContext";

import Auth from "./pages/Login"

function App() {
  const loginContext = useContext(LoginContext);  
  const { token, isAdmin } = loginContext;

  const path = process.env.CONTEXT_PATH ? `${process.env.CONTEXT_PATH}` : '/idesoft';

  return (
      <BrowserRouter basename={path}>
        <div className="App">
          {token ? 
            <Router path={path} isAdmin={isAdmin()}/>:
            <Auth />
          }
        </div>
      </BrowserRouter>
    );
}

export default App;
